import React from 'react'
import { connect } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import { setChartToForm } from '../reducers/chartFormReducer'


const NewChartConfirmationModal = (props) => {
  // PROPS
  const { show, routerProps } = props

  const handleRedirect = () => routerProps.history.replace("/charts")

  return (
    <Modal
      show={ show }
      onHide={ props.toggleShow || handleRedirect }
      dialogClassName="modal-wide"
      size="sm"
    >
      <Modal.Header closeButton>
        New Chart
      </Modal.Header>

      <Modal.Body>
       <center>
         <h5>
           There are already 20 approved charts at this site.
         </h5>
       </center>
      </Modal.Body>

      <Modal.Footer>
        { routerProps.location.pathname === "/charts/new" ?
          <Button onClick={ () => routerProps.history.replace("/charts") } variant="secondary">Go Back to Charts</Button>
          :
          <React.Fragment>
            { process.env.REACT_APP_MODE === "DEMO" ?
              <Button onClick={ () => routerProps.history.replace("/charts/new") } variant="secondary">Continue</Button>
              :
              null
            }
            <Button onClick={ props.toggleShow } variant="secondary">Close</Button>
          </React.Fragment>
        }
      </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    incompleteCharts: state.chartsReducer.incompleteCharts,
  }
}

const mapDispatchToProps = {
    setChartToForm
}


export default connect(mapStateToProps, mapDispatchToProps)(NewChartConfirmationModal)
